
// src/pages/Contact.js

import React, { useEffect } from "react";

import "./contact.css";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import { setPageMeta } from "../utils/seo";

const Contact = () => {

  useEffect(() => {
    setPageMeta({
      title: "Contact Banat India | Customer Support",
      description:
        "Get in touch with Banat India for orders, support, and product questions.",
      keywords:
        "contact Banat India, customer support, oral care help, toothbrush support",
    });
  }, []);

  return (

    <section className="contact-section">

      {/* HEADER */}

      <div className="contact-header">

        <span className="contact-tag">
          GET IN TOUCH
        </span>

        <h2>
          We’d Love <br />
          To Hear From You
        </h2>

        <p>
          Whether you have questions about our products,
          orders or partnerships — our team is here to help.
        </p>

      </div>

      {/* CONTACT GRID */}

      <div className="contact-grid">

        {/* ADDRESS */}

        <a
          href="https://www.google.com/maps?q=3-601/2+First+Floor,+Pedda+Golconda,+Shamshabad,+Hyderabad,+India+501218"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card"
        >

          <div className="contact-icon">
            <FaMapMarkerAlt />
          </div>

          <h3>Visit Us</h3>

          <p>
            3-601/2 First Floor,
            Pedda Golconda,
            Shamshabad,
            Hyderabad – 501218
          </p>

        </a>

        {/* PHONE */}

        <a
          href="tel:+917207149900"
          className="contact-card"
        >

          <div className="contact-icon">
            <FaPhoneAlt />
          </div>

          <h3>Call Us</h3>

          <p>
            +91 7207149900
          </p>

        </a>

        {/* EMAIL */}

        <a
          href="mailto:info@parwahindustries.com"
          className="contact-card"
        >

          <div className="contact-icon">
            <FaEnvelope />
          </div>

          <h3>Email Us</h3>

          <p>
            info@parwahindustries.com
          </p>

        </a>

      </div>

    </section>
  );
};

export default Contact;

